import React, { useState } from "react";
import { CurrencyExchange } from "@mui/icons-material";
import { Button, Modal, Select } from "antd";
import { BeatLoader } from "react-spinners";
import http from "../../services/http";
import { toast } from "react-toastify";
import "./styles.scss";

function SubscriptionModal({ preview, closeHandler }) {
  const [isYearly, setisYearly] = useState(false);
  const [isPaymentLoading, setPaymentLoading] = useState(false);

  const handleSubmit = () => {
    setPaymentLoading(true);
    http
      .post("subscription", { plan: isYearly ? "yearly" : "monthly" })
      .finally(() => setPaymentLoading(false))
      .then(({ data }) => {
        window.location.href = data.url;
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      });
  };

  return (
    <Modal
      centered
      width={350}
      open={preview}
      onCancel={closeHandler}
      footer={null}
      className="purchase-subscription"
    >
      <h2 className="title">Choose Your Plan</h2>
      <p className="description">
        Choose the duration of your plan and proceed with your subscription.
      </p>
      <div className="detail">
        <CurrencyExchange />
        <h3>Professional</h3>
        <h4>${isYearly ? "540.00 / year" : "50.00 / month"}</h4>
      </div>
      <label>Billing cycle</label>
      <Select
        placeholder="Select plan"
        value={isYearly ? "yearly" : "monthly"}
        onChange={(val) => setisYearly(val === "yearly")}
      >
        <Select.Option value="monthly">Monthly</Select.Option>
        <Select.Option value="yearly">Yearly</Select.Option>
      </Select>
      <Button
        className="submit-btn"
        type="primary"
        htmlType="submit"
        onClick={handleSubmit}
      >
        {isPaymentLoading ? (
          <BeatLoader color="#fff" size={8} />
        ) : (
          "Proceed to checkout"
        )}
      </Button>
    </Modal>
  );
}

export default SubscriptionModal;
